import {Component, Event, type EventEmitter, h, Prop} from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-dashboard-tab-button',
  styleUrl: 'uiaas-dashboard-tab-button.scss',
  shadow: false,
})
export class UiaasDashboardTabButton {
  /**
   * Set target tab for redirection
   */
  @Prop() readonly targetTab: string;

  /**
   * Set tab name
   */
  @Prop() readonly tabName?: string;

  /**
   * Text displayed
   */
  @Prop() readonly buttonText?: string;

  /**
   * Translations provider
   */
  @Prop() readonly labelProvider: labelProviderInterface;

  @Prop() readonly isMobile?: boolean = false;

  /**
   * Tab count inherited from wrapper
   */

  @Event({
    eventName: 'search:dashboardViewAll',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    viewAllEventEmmiter: EventEmitter;

    
  private handleClickAction = () => {
      const searchElement = document.querySelector('uiaas-search')?.shadowRoot;
      const item = searchElement?.querySelector(
        `[data-tab-name="${this.targetTab}"]`
      ) as HTMLElement;
      window.scrollTo({top: 0, behavior: 'smooth'});
      setTimeout(() => {
          item.click();
      }, 500);
      this.viewAllEventEmmiter.emit({
        isViewAllClicked: true,
        tabName: this.targetTab,
      });
  };

  render() {
      const viewAllText = this.labelProvider('tab.dashboard.view-all', 'View all');
      const sectionTitle = this.tabName || this.targetTab || '';
      const ariaLabel = `${viewAllText} ${sectionTitle}`;
      return (
        <div class="dashboard__tab-button">
          <qds-button
            aria-label={ariaLabel}
            size={this.isMobile ? 'small' : 'standard'}
            text={this.isMobile ? '' : this.labelProvider('tab.dashboard.view-all', 'View all')}
            onClick={this.handleClickAction}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  this.handleClickAction();
                }
            }}
            icon-only={this.isMobile}
            icon-name={this.isMobile ? 'chevron-right' : ''}
          >
          </qds-button>
        </div>
      );
  }
}
